import React from 'react';

const Footer = ({ 
  className = "",
  poweredBy = "CityGroup IT",
  copyright = "© All rights reserved",
  showPoweredBy = true
}) => {
  return (
    <footer className={`text-center mt-8 ${className}`}>
      <div className="bg-gray-900/90 backdrop-blur-md rounded-2xl px-6 py-3 inline-block border border-cyan-500/30 shadow-lg shadow-cyan-500/10">
        <div className="flex items-center justify-center gap-2">
          {showPoweredBy && (
            <>
              <svg className="w-4 h-4 text-cyan-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
              </svg>
              <p className="text-gray-200 text-sm font-medium">
                Powered by <span className="text-cyan-400 font-bold ml-1">{poweredBy}</span>
              </p>
              <span className="text-gray-500 mx-2">•</span>
            </>
          )}
          <p className="text-gray-400 text-xs font-light">
            {copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;